import { render, staticRenderFns } from "./AcademyWrapper.vue?vue&type=template&id=32bb6a2c&scoped=true&"
import script from "./AcademyWrapper.vue?vue&type=script&lang=js&"
export * from "./AcademyWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AcademyWrapper.vue?vue&type=style&index=0&id=32bb6a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb6a2c",
  null
  
)

export default component.exports